export class GroupManagementError extends Error {
    constructor(message) {
        super('Group operation failed: ' + message);
    }
}
